import { PRODUCT_KEYS } from "../../constants/products";

// isEligibleForProduct true means this field is eligible for the corresponding products
// and false means eligible for remaining products except this
export const ProductFieldEligibility = {
  isGSTWaiver: { products: [PRODUCT_KEYS.GPP_FLEXI], isEligibleForProduct: true },
};
